export default "__VITE_ASSET__150366ca__"